import script from "./CenterEvaluation.vue?vue&type=script&setup=true&lang=js"
export * from "./CenterEvaluation.vue?vue&type=script&setup=true&lang=js"

import "./CenterEvaluation.vue?vue&type=style&index=0&id=5eeb3f54&lang=css"

const __exports__ = script;

export default __exports__